import { render, staticRenderFns } from "./UserAdminForm.vue?vue&type=template&id=deb1d354&scoped=true"
import script from "./UserAdminForm.vue?vue&type=script&lang=js"
export * from "./UserAdminForm.vue?vue&type=script&lang=js"
import style0 from "./UserAdminForm.vue?vue&type=style&index=0&id=deb1d354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb1d354",
  null
  
)

export default component.exports